(function () {
  
  function initMarqueeScroll(scope = document) {
    scope.querySelectorAll('[data-marquee-scroll-direction-target]').forEach((marquee) => {
      // prevent double init
      if (marquee.dataset.marqueeInit === "true") return;
      marquee.dataset.marqueeInit = "true";

      const content = marquee.querySelector('[data-marquee-collection-target]');
      const scroll = marquee.querySelector('[data-marquee-scroll-target]');
      if (!content || !scroll) return;

      const baseSpeed = parseFloat(marquee.dataset.marqueeSpeed) || 20;
      const direction = marquee.dataset.marqueeDirection === "right" ? 1 : -1;
      const duplicates = parseInt(marquee.dataset.marqueeDuplicate) || 1;

      // duplicate rows
      for (let i = 0; i < duplicates; i++) {
        scroll.appendChild(content.cloneNode(true));
      }

      const items = marquee.querySelectorAll('[data-marquee-collection-target]');

      // responsive speed
      const speedMultiplier =
        window.innerWidth < 479 ? 0.25 :
        window.innerWidth < 991 ? 0.5 : 1;

      const duration =
        baseSpeed * (content.offsetWidth / window.innerWidth) * speedMultiplier;

      const tween = gsap.to(items, {
        xPercent: direction === 1 ? 100 : -100,
        duration,
        ease: "none",
        repeat: -1,
        modifiers: { xPercent: gsap.utils.wrap(-100, 0) }
      });

      // pause on hover
      marquee.addEventListener("mouseenter", () => tween.pause());
      marquee.addEventListener("mouseleave", () => tween.play());
    });
  }

  /* ---------- INITIAL LOAD ---------- */
  document.addEventListener("DOMContentLoaded", () => {
    initMarqueeScroll();
  });

  /* ---------- SHOPIFY AJAX SECTIONS ---------- */
  document.addEventListener("shopify:section:load", (e) => {
    initMarqueeScroll(e.target);
  });

  /* ---------- RESIZE (recalculate safely) ---------- */
  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      gsap.killTweensOf('[data-marquee-collection-target]');
      document.querySelectorAll('[data-marquee-scroll-direction-target]')
        .forEach(el => el.dataset.marqueeInit = "false");

      initMarqueeScroll();
    }, 300);
  });
})();
